<script>
    export let short = false;
    export let ajankohtaistaUrl = "2025-04-12_paasiainen";
    let title = "Pääsiäisen ryhmätreenitajat";
    let titlePic = "/svelte-site/img/ajankohtaista/koysi.jpg";
    let firstPara = "Pääsiäisen aikana ryhmätreenejä ei ole sunnuntaina eikä maanantaina.";
</script>
<!--  Ajankohtaista -kirjoitukset koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
    <div class="blogSummary">
        <a href="/ajankohtaista/{ajankohtaistaUrl}">
            <span class="articleImage"
                  style="background-image: url('{titlePic}"></span>
            <span>
            <span class="blogTitle">{title}</span>
            <span class="blogShortContent">{firstPara}</span>
        </span>
        </a>
    </div>

{:else}
    <div class="blog page">
        <article class="container">
            <div class="row">
                <div class="col-xs-12 col-md-8">
                    <h1>{title}</h1>
                    <p>Sali on normaalisti auki omatoimitreenille koko pääsiäisen ajan klo 05-23.</p>
                    <p>Pääsiäisen aikaan pidetään vielä lauantain Savotta normaalisti klo 11.00</p>
                    <p>Ensimmäisenä pääsiäispäivänä sunnuntaina (20.4.) ei pidetä kehonhuoltoa, eikä toisena pääsiäispäivänä
                    maanantaina (21.4.) pidetä ryhmätreenejä tai päivystystä.</p>
                    <p>Näet ryhmäreenien tilanteen myös salin kalenterista <a href="/treenit-aukioloajat">täältä.</a></p>
                </div>
                <div class="col-xs-12 col-md-4">
                    <img src="/svelte-site/img/ajankohtaista/koysi.jpg"/>
                </div>
            </div>
        </article>
    </div>
{/if}
